<template>
  <van-overlay :show="requestLoading" @click.stop class="pageLoading">
    <van-loading size="48px" color="#1989fa" vertical>{{
      requestLoadingText ? requestLoadingText : '数据加载中...'
    }}</van-loading>
  </van-overlay>
  <router-view />
</template>

<script setup lang="ts">
  // import copyPaste from '@/utils/lib/copy-paste';
  import { ipAddr } from '@/api/login';
  import { storage } from '@/utils/storage';
  import { useMyLoading } from '@/store/modules/loading';
  import { storeToRefs } from 'pinia';
  import { useUserStore } from '@/store/modules/user';
  import { throttle } from 'lodash-es';

  // import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
  // import { IObjStr } from '@/utils/http';
  // import { guestUserInfoAuthState } from '@/pages/pageListAll/pageTwo/main';
  import useClipboard from 'vue-clipboard3';
  import { pageInitRequest } from '@/hooks/useInitBasic';
  import { baseDayTimeMethod, createdGuid } from '@/utils/common';
  const { toClipboard } = useClipboard();
  const { buriedPointNoTokenFn } = pageInitRequest();

  const useMyLoading_ = useMyLoading();
  const { requestLoading, requestLoadingText } = storeToRefs(useMyLoading_);
  const { setCity } = useUserStore();
  const getUrlParam = (paramName: string) => {
    // 从 window.location.href 中获取查询字符串（URL 中问号及后面的部分）
    const queryString = window.location.search;
    // 如果没有查询字符串，直接返回 null
    if (!queryString) {
      return null;
    }
    // 去掉问号，获取真正的参数部分
    const params = queryString.substring(1);
    // 将参数部分按 & 分割成数组
    const paramPairs = params.split('&');
    // 遍历参数对
    for (const pair of paramPairs) {
      // 对每个参数对按 = 分割成键值对
      const [name, value] = pair.split('=');

      // 解码参数名和参数值（处理 URL 编码）
      const decodedName = decodeURIComponent(name);
      const decodedValue = decodeURIComponent(value || '');

      // 如果找到匹配的参数名，返回其值
      if (decodedName === paramName) {
        return decodedValue;
      }
    }
    // 没找到匹配的参数名，返回 null
    return null;
  };
  onMounted(() => {
    if (!(storage.getItem('channelId', 2) || window.location.href.indexOf('channelId') >= 0)) {
      buriedPointNoTokenFn(true, [
        {
          currentPageCode: '',
          currentPageName: '',
          fromPageCode: '',
          fromPageName: '',
          eventCode: 'JR_H5_USER_KEY_CLICK',
          extraDataJson: { keyName: 'app页面地址URL', keyContent: window.location.href },
          logTime: baseDayTimeMethod.getDateTime(),
        },
      ]);
    }
    storage.removeItem('goNewPage', 2);
    storage.removeItem('noChannelId', 2);
    storage.removeItem('channelIdIsPoint', 2);
    storage.removeItem('selectCar', 2);
    storage.removeItem('envPreview', 2);
    const val = getUrlParam('channelId');
    if (val) {
      storage.setItem('channelId', val, null, 2);
    }
    buriedPointNoTokenFn(true, [
      {
        currentPageCode: 'ysr100000',
        currentPageName: '系统首页',
        fromPageCode: '',
        fromPageName: '',
        logTime: baseDayTimeMethod.getDateTime(),
        eventCode: 'JR_H5_USER_PAGE_VIEW',
        extraDataJson: {
          burSystem: 1,
        },
      },
    ]);
    /**不可粘贴*/
    // copyPaste.disable();
    if (!/404/.test(window.location.href)) {
      ipAddr().then((res) => {
        storage.setItem('localCity', res.city, null, 2);
        if (storage.getItem('cityChoose', 2) == null) {
          storage.setItem('cityChoose', res.city, null, 2);
        }
        setCity(res.city);
      });
    }
    /** 生成clickId 存本地 */
    const clickId = createdGuid();
    storage.setItem('clickId', clickId, null, 2);

    window.addEventListener('click', throttle_, false);
  });
  const throttle_ = throttle((e) => initCopyFn(e), 2500, { leading: true, trailing: false });

  const initCopyFn = async (e: any) => {
    const envPreview = storage.getItem('envPreview', 2);
    if (e.target.nodeName == 'INPUT' || envPreview == 'mini') {
      return;
    }
    const channelId_ = storage.getItem('channelId', 2);
    const channelIdIsPoint_ = storage.getItem('channelIdIsPoint', 2);
    const clickId_ = storage.getItem('clickId', 2) || '';
    const userId_ = storage.getItem('userId', 2) || '';
    let xdPage = storage.getItem('xdPage', 2) || '';
    if (channelId_) {
      let text = `XDCHANNELDI-${channelId_}&-288888888&${userId_}&${clickId_}`;
      try {
        if (xdPage) {
          text += `&xdPage=${xdPage}`;
        }
        if (text) {
          await toClipboard(text);
        }
        // await toClipboard(`XDCHANNELDI-${channelId_}&-288888888&${userId_}&${clickId_}`);
        if (!channelIdIsPoint_) {
          buriedPointNoTokenFn(true, [
            {
              currentPageCode: '',
              currentPageName: '',
              fromPageCode: '',
              fromPageName: '',
              logTime: baseDayTimeMethod.getDateTime(),
              eventCode: 'JR_H5_CHANNELID_CLIPBOARD',
              extraDataJson: {
                isWrite: 1,
              },
            },
          ])?.finally(() => {
            storage.setItem('channelIdIsPoint', true, null, 2);
          });
        }
        console.log(`XDCHANNELDI-${channelId_}`);
      } catch (e) {
        if (!channelIdIsPoint_) {
          buriedPointNoTokenFn(true, [
            {
              currentPageCode: '',
              currentPageName: '',
              fromPageCode: '',
              fromPageName: '',
              logTime: baseDayTimeMethod.getDateTime(),
              eventCode: 'JR_H5_CHANNELID_CLIPBOARD',
              extraDataJson: {
                isWrite: 0,
              },
            },
          ])?.finally(() => {
            storage.setItem('channelIdIsPoint', true, null, 2);
          });
        }
        console.log(e);
      }
      /*toClipboard(`XDCHANNELDI-${channelId_}`).then(
        (res) => {
          console.log(res, 55)
          if (!channelIdIsPoint_) {
            buriedPointNoTokenFn(true, [
              {
                currentPageCode: '',
                currentPageName: '',
                fromPageCode: '',
                fromPageName: '',
                logTime: baseDayTimeMethod.getDateTime(),
                eventCode: 'JR_H5_CHANNELID_CLIPBOARD',
                extraDataJson: {
                  isWrite: 1,
                },
              },
            ])?.finally(() => {
              storage.setItem('channelIdIsPoint', true, null, 2);
            });
          }
        },
        (err) => {
          console.log(err, 76)
          if (!channelIdIsPoint_) {
            buriedPointNoTokenFn(true, [
              {
                currentPageCode: '',
                currentPageName: '',
                fromPageCode: '',
                fromPageName: '',
                logTime: baseDayTimeMethod.getDateTime(),
                eventCode: 'JR_H5_CHANNELID_CLIPBOARD',
                extraDataJson: {
                  isWrite: 0,
                },
              },
            ])?.finally(() => {
              storage.setItem('channelIdIsPoint', true, null, 2);
            });
          }
        }
      );*/
    }
  };

  onBeforeUnmount(() => {
    window.removeEventListener('click', throttle_, false);
    // copyPaste.enable();
  });
</script>

<style>
  #app {
    font-family: Inter, Avenir, Helvetica, Arial, sans-serif;
    font-synthesis: none;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
  }
  .pageLoading {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
